function removeHiddenText(){
    const hiddenText = document.querySelector('.hidden-text');
    hiddenText.classList.remove('on');
}
export default removeHiddenText;


